<template>
  <div class="admin-login-page">
    <div class="login-form">
      <div class="login-form-box">
        <h1>Admin</h1>
        <el-input v-model="username" placeholder="E-mail"></el-input>
        <el-input v-model="password" placeholder="Password" show-password></el-input>
        <el-button @click="clickLogin()">Sign In</el-button>
      </div> 
    </div>  
  </div>
</template>

<script>
export default {
  data(){
    return{
      username: '',
      password: '',
    }
  },
  methods: {
    clickLogin: function(){
      console.log("Admin Login")
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/admin/login';
      let dataLogin = {
        account: that.username,
        password: btoa(that.password),
      }
      console.log(dataLogin)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(dataLogin),
        contentType: "application/json",
        success: function(data) {
          console.log('success', data)
          if(data.code === 200){
            that.$router.push({ path: "/ControlPanel" })
            that.setLocalStorage('admintoken', data.data.token)
          }
          if(data.code === 400){
            that.$message({
              duration: 0,
              offset: 80,
              showClose: true,
              message: data.error,
              type: 'error'
            })            
          }
        },
        error: function(response) {
          console.log('error', response)
        }
      })
    }
  }
}
</script>
